import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { ReportKind, ReportQuery, ReportResult } from './types';

export interface ReportsRepository {
  run(kind: ReportKind, query: ReportQuery, signal: AbortSignal): Promise<ReportResult>;
}

export const reportsRepositoryToken = createRepositoryToken<ReportsRepository>('reports');
